import { find, map, pick } from 'lodash';

function Deployment(Api, $location, $q) {
  'ngInject';

  return {
    fetch: fetch
  };

  /**
   * @returns {Promise}
   */
  function fetch() {

    var host = _getQAHost();

    return host ?
      _requestDeployments(host) :
      $q.when([]);

  }

  /**
   * Returns the QA host if it matches the current host
   *
   * @returns {(String|null)}
   * @private
   */
  function _getQAHost() {

    return find(['qa-1.adjust.com', 'qa-2.adjust.com'], function(h) {
      return $location.host().indexOf(h) > -1;
    });

  }

  /**
   * Safely fetches deployments without propagating errors. In case of failure
   * an empty array is resolved.
   *
   * @returns {Promise}
   * @private
   */
  function _requestDeployments(host) {

    return Api.deployments.query({host: host})
      .$promise
      .then(_preparePayload)
      .catch(() => []);

  }

  /**
   * Fixes the broken github URLs due to the angular-dashboard's beta hack.
   * Sets a default value in case the username is mising
   *
   * @param {[Deployment]?} resp
   * @returns {[Deployment]}
   * @private
   */
  function _preparePayload(resp) {
    const deployments = resp || [];

    return map(deployments, item => {
      const fields = pick(item, ['project', 'branch', 'created_at']);
      const username = item.username || 'N/A';
      const revision_url = item.project === 'angular-dashboard-beta'
        ? item.revision_url.replace('angular-dashboard-beta', 'angular-dashboard')
        : item.revision_url;

      return {
        ...fields,
        username,
        revision_url
      };
    });
  }
}

export { Deployment };
